import React, { useCallback } from 'react'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'

import { DemoTradingAccountNavigation } from '../Navigation/DemoTradingAccountNavigation'
import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import TradingAccountPositionsTable from './TradingAccountPositionsTable'

import '../TradingAccount.scss'

interface Props {
  data: {
    id: string
    name: string
  }
}

const DemoTradingAccountPositionsPage: React.FC<Props> = ({ data }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const fetchData = useCallback(() => {
    return tradingAccountsApiClient.getDemoTradingAccountOpenPositions(data.id)
  }, [data.id]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data: tradingAccountPositions, isLoading } = useFetchOne(fetchData)

  return (
    <React.Fragment>
      <DemoTradingAccountNavigation data={data} isEdit={false} tab={TradingAccountTab.Positions} />
      <Loading isLoading={isLoading}>
        {tradingAccountPositions && (
          <TradingAccountPositionsTable
            data={data}
            tradingAccountPositions={tradingAccountPositions}
          />
        )}
      </Loading>
    </React.Fragment>
  )
}

export default DemoTradingAccountPositionsPage
